class FetchError {
    request: RequestInit;
    error: Response;
    url: string;

    constructor(request: RequestInit, error: Response, url: string) {
        this.request = request;
        this.error = error;
        this.url = url;

        console.error("FetchError", request, error, url);
    }
}

export default FetchError;
